import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { AdminReportController } from 'cd-eft/services/eftPrjAdminApi';
import { observable, action } from 'mobx';

type FilterTypes = 'dateFilter' | 'dateRange';

export class AdminReportsVM {
  readonly currentDate: Date;
  readonly currentDateFormatted: string;
  constructor() {
    this.currentDate = new Date();
    this.currentDateFormatted = this.getMaxEndDateString(this.currentDate);
  }
  @observable dateMethod: FilterTypes = 'dateFilter';
  @observable quickSelectRange: string = '0'; // 0-7
  // start & end format? yyyy-mm-dd
  @observable startDate = {
    string: '',
    number: 0,
  };
  @observable endDate = {
    string: '',
    number: 0,
  };
  @observable formValidation = {
    startDate: false,
    endDate: false,
    range: false,
    hasError: false,
  };

  @observable loading = false;
  @observable loadingMessage = '';

  @action.bound selectDateMethod(event) {
    const { value } = event.target;
    this.dateMethod = value;
  }

  @action.bound selectRangeHandler(event) {
    const { value } = event.target;
    this.quickSelectRange = value;
    this.formValidation.hasError = false;
  }
  @action.bound setStartDate(event) {
    const { value, valueAsNumber } = event.target;
    this.startDate.string = value;
    this.startDate.number = valueAsNumber;
    this.formValidation.hasError = false;
  }
  @action.bound setEndDate(event) {
    const { value, valueAsNumber } = event.target;
    this.endDate.string = value;
    this.endDate.number = valueAsNumber;
    this.formValidation.hasError = false;
  }

  @action.bound async validateChosenInputs() {
    switch (this.dateMethod) {
      case 'dateFilter':
        // Anything to validate here?
        const x = parseInt(this.quickSelectRange);
        if (x < 0 || x > 7) {
          this.formValidation.hasError = true;
          this.formValidation.range = true;
        }
        else {
          this.formValidation.range = false;
          this.formValidation.hasError = false;
        }
        
        break;
      case 'dateRange':
        if (this.endDate.number < this.startDate.number || this.endDate.string === '' || this.startDate.string === '') {
          this.formValidation.endDate = true;
          this.formValidation.startDate = true;
          this.formValidation.hasError = true;
          if (this.endDate.string === '' || this.startDate.string === '') {
            await MessageCenter.addNotificationFromCode('Common_17', undefined, 'Date Range');
          }
          else {
            await MessageCenter.addNotificationFromCode('Common_22');
          }
        }
        else {
          this.formValidation.endDate = false;
          this.formValidation.startDate = false;
          this.formValidation.hasError = false;
        }
        break;
      default:
        this.formValidation.hasError = true;
        break;
    }
  }

  @action.bound async getCsvData() {
    // Validate Here
    this.validateChosenInputs();
    if (this.formValidation.hasError) {
      // await MessageCenter.addNotificationFromCode('Common_19')
      return;
    }
    this.loading = true;
    this.loadingMessage = 'Generating CSV...';

    let filterType: number | undefined = undefined;
    let startString: string | undefined = undefined;
    let endString: string | undefined = undefined;

    if (this.dateMethod === 'dateFilter') {
      filterType = +this.quickSelectRange;
    } else {
      startString = this.startDate.string;
      endString = this.endDate.string;
    }

    try {
      const response: any = await AdminReportController.generateAndDownloadUserActivityAdminReportCSVUsingGET(
        filterType,
        startString,
        endString
      );
      if (response && response.data) {
        this.loadingMessage = 'Downloading File...';
        const csvData = new Blob([response.data], { type: 'text/csv' });
        const fileLocation = window.URL.createObjectURL(csvData);
        const link = document.createElement('a');
        link.href = fileLocation;
        link.download = this.createFileName();
        link.click();
      }
    } catch (error) {
      console.error(error);
      await MessageCenter.addNotificationFromCode('Common_18')
    } finally {
      this.loading = false;
      this.loadingMessage = '';
    }
  }

  getMaxEndDateString(date: Date) {
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString();
    const day = date.getDate().toString();
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  createFileName(): string {
    const timestamp = new Date();
    let filename = 'nets_system_admin_user_activity_report';
    filename +=
      '_' +
      timestamp.getUTCFullYear().toString() +
      (timestamp.getUTCMonth() + 1).toString().padStart(2, '0') +
      timestamp.getUTCDate().toString().padStart(2, '0') +
      '_' +
      timestamp.getUTCHours().toString().padStart(2, '0') +
      timestamp.getUTCMinutes().toString().padStart(2, '0') +
      timestamp.getUTCSeconds().toString().padStart(2, '0');
    return `${filename}.csv`;
  }
}
